import {
    TOAST
} from "./actionTypes";
import {
    ITodo,
    OpenToast,
} from "./types";

export const openToast = (
    payload: ITodo
): OpenToast => ({
    type: TOAST,
    payload,
});

